// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-invitation-list-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.add-invitation-list-modal-content {
  width: 500px;
  background: #ffffff;
  border-radius: 16px;
  padding: 4%;
}
.add-invitation-list-modal-content__modal-action__close {
  cursor: pointer;
}
.add-invitation-list-modal-content__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 32px;
  color: #333333;
}
.add-invitation-list-modal-content__input {
  margin-top: 40px;
}
.add-invitation-list-modal-content__date-range {
  display: flex;
  margin-top: 40px;
}
.add-invitation-list-modal-content__date-range__start {
  width: 50%;
  padding-right: 5px;
}
.add-invitation-list-modal-content__date-range__end {
  width: 50%;
  padding-left: 5px;
}
.add-invitation-list-modal-content__buttons {
  display: flex;
  margin-top: 40px;
}
.add-invitation-list-modal-content__buttons__cancel {
  width: 50%;
  margin-right: 5px;
}
.add-invitation-list-modal-content__buttons__submit {
  width: 50%;
  margin-left: 5px;
}`, "",{"version":3,"sources":["webpack://./src/components/employee-registration/bulk-registration/add-invitation-list-modal/add-invitation-list.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AACJ;AAEQ;EACI,eAAA;AAAZ;AAII;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFR;AAKI;EACI,gBAAA;AAHR;AAMI;EACI,aAAA;EACA,gBAAA;AAJR;AAMQ;EACI,UAAA;EACA,kBAAA;AAJZ;AAOQ;EACI,UAAA;EACA,iBAAA;AALZ;AASI;EACI,aAAA;EACA,gBAAA;AAPR;AASQ;EACI,UAAA;EACA,iBAAA;AAPZ;AAUQ;EACI,UAAA;EACA,gBAAA;AARZ","sourcesContent":[".add-invitation-list-modal {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.add-invitation-list-modal-content {\n    width: 500px;\n    background: #ffffff;\n    border-radius: 16px;\n    padding: 4%;\n\n    &__modal-action {\n        &__close {\n            cursor: pointer;\n        }\n    }\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 22px;\n        line-height: 32px;\n        color: #333333;\n    }\n\n    &__input {\n        margin-top: 40px;\n    }\n\n    &__date-range {\n        display: flex;\n        margin-top: 40px;\n\n        &__start {\n            width: 50%;\n            padding-right: 5px;\n        }\n\n        &__end {\n            width: 50%;\n            padding-left: 5px;\n        }\n    }\n\n    &__buttons {\n        display: flex;\n        margin-top: 40px;\n\n        &__cancel {\n            width: 50%;\n            margin-right: 5px;\n        }\n\n        &__submit {\n            width: 50%;\n            margin-left: 5px;\n        }\n    }\n\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
